//import _ from 'lodash'
import moment from 'moment'

import utility from '@/mixins/utility'

class Action {

  #data = {}

  #pipeline = {}

  #provider = {}

  #target = {}

  constructor(data={})
  {  
    this.#data = data

    if( data.pipeline )
      this.#pipeline = utility.methods.mapModel(data.pipeline, 'pipeline')

    // can be user or group!
    if( data.target )
      this.#target = utility.methods.mapModel(data.target, 'user')

    if( data.provider )
      this.#provider = utility.methods.mapModel(data.provider, 'provider')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active
  }

  get canStart()
  {
    return this.#data.can_start
  }

  get completedAt()
  {
    let data = this.#data.completed_at

    return data ? moment(data) : null
  }

  get component()
  {
    return this.#data.component
  }

  get componentMeta()
  {
    return this.#data.component_meta || {}
  }

  get description()
  {
    return this.#data.description
  }

  get icon()
  {
    return this.#data.icon
  }

  get image()
  {
    return this.#data.image
  }

  get id()
  {
    return this.#data.id
  }

  get meta()
  {
    return this.#data.meta
  }

  get name()
  {
    return this.#data.name
  }


  /**
   * Relationships.
   */

   get pipeline()
   {
    return this.#pipeline
   }

   get provider()
  {
    return this.#provider
  }

   get target()
   {
    return this.#target
   }
  

  /**
   * Computed properties.
   */
  
  get isCompleted()
  {
    return !!this.completedAt
  }

  get isPending()
  {
    return this.canStart && !this.isCompleted
  }


  /**
   * Methods.
   */

   complete()
   {
    this.#data.completed_at = moment().format('YYYY-MM-DD HH:mm:ss')
   }
}

export default Action